import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { constantUrl } from 'src/app/Shared/constantUrl';
import { MasterService } from '../../../../app/Shared/app.Masters.Service';
declare var $: any;
@Component({
  selector: 'app-crc-subcard-info',
  templateUrl: './crc-subcard-info.component.html',
  styleUrls: ['./crc-subcard-info.component.scss'],

})
export class CRCSubcardInfoComponent implements OnInit {
@Input() crcData:any
crcAttachement:any;
  @Input() applicationId: any
  @Input() index: any;
  private _MasterService;
  cibilResponseMain: any;
  cibilResponseSurePass: any;
  experianResponse: any;
  constructor(private MasterService: MasterService) {
    this._MasterService = MasterService;
}

  ngOnInit(): void {
    console.log("crcData", this.crcData);
    this.crcAttachement= `${constantUrl.CrcApplicationDocUrl}${this.applicationId}`
  }

  getCRCThirdDetail(crc:any) {
    this._MasterService.Get_CibilAPI_Request_Response({ Loan_Id: crc.CRC_LoanId, CId: crc["CRC_CustomerId"], CrcId: 0 })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          this.cibilResponseMain = JSON.parse(res[0].response);
         
          $(`#cibilReportmain${this.index}`).modal("show");
          $(`#cibilReportmain${this.index}`).css("z-index", "1090");
        }
      })
  }
  getCRCThirdSurePassDetail(crc:any) {
    this._MasterService
      .Get_CibilAPI_Request_Response({
        Loan_Id: crc.CRC_LoanId,
        CId: crc["CRC_CustomerId"],
        CrcId: 1
      })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          this.cibilResponseSurePass = JSON.parse(res[0].response);

          $(`#cibilReportSurePass${this.index}`).modal("show");
          $(`#cibilReportSurePass${this.index}`).css("z-index", "1050");
        }
      });
  }
  getCRCThirdexperianSurepassDetail(crc:any) {
    this._MasterService
      .Get_CibilAPI_Request_Response({
        Loan_Id: crc.CRC_LoanId,
        CId: crc["CRC_CustomerId"],
        CrcId: 3
      })
      .subscribe((res: any) => {
        console.log("res", res);
        if (res.length > 0) {
          this.experianResponse = JSON.parse(res[0].response);

          $(`#experianReport${this.index}`).modal("show");
          $(`#experianReport${this.index}`).css("z-index", "1050");
        }
      });
  }



  onCloseCibilmainReport() {
    $(`#cibilReportmain${this.index}`).modal("hide");
  }
  onCloseExperianReportModel() {
    $(`#experianReport${this.index}`).modal("hide");

  }
  onClosecibilReportSurePass() {
    $(`#cibilReportSurePass${this.index}`).modal("hide");

  }
}
